import "./nav_bar.scss";
import React, { useContext, useState } from "react";

import languageContext from "../../context/languageContext";

const Nav_Bar = () => {
  const [open, setOpen] = useState(false);

  const navClass = open && "--modal";

  const { language } = useContext(languageContext);

  return (
    <header
      className={`navigation-container navigation-container${navClass}`}
      onClick={() => setOpen(!open)}
    >
      <ul className={`anchor-list anchor-list${navClass}`}>
        <li className="anchor-list__items" onClick={() => setOpen(false)}>
          <a href="#inicio">{language.navbar.home}</a>
        </li>
        <li className="anchor-list__items" onClick={() => setOpen(false)}>
          <a href="#sobre-mi">{language.navbar.about}</a>
        </li>
        <li className="anchor-list__items" onClick={() => setOpen(false)}>
          <a href="#proyectos-y-trabajos">{language.navbar.work}</a>
        </li>
        <li className="anchor-list__items" onClick={() => setOpen(false)}>
          <a href="#contact-page">{language.navbar.contact}</a>
        </li>
      </ul>
    </header>
  );
};

export default Nav_Bar;
